const dayjs = require("dayjs");

function dateFormat(date) {
  try {
    return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
  } catch (error) {
    console.error("Error formatting date:", error);
    return date; // Return the original date if formatting fails
  }
}
module.exports = dateFormat;
